import { browser } from '$app/environment';

class BreakPoints {
	public currentWidth = $state(0);
	public tn = $derived(this.currentWidth >= 320);
	public xs = $derived(this.currentWidth >= 460);
	public sm = $derived(this.currentWidth >= 700);
	public md = $derived(this.currentWidth >= 980);
	public lg = $derived(this.currentWidth >= 1240);
	public xl = $derived(this.currentWidth >= 1700);

	constructor() {
		if (!browser) return;

		const updateWidth = () => {
			this.currentWidth = window.innerWidth;
		};
		window.addEventListener('resize', updateWidth);
		updateWidth();
	}
}

export const breakpoints = new BreakPoints();
